<template>
   <DashboardAffiliate msg="Welcome to Dashboard ( Home )"/>
</template>

<script>
// @ is an alias to /src
import DashboardAffiliate from "@/components/Dashboard/DashboardForAffiliate.vue";

export default {
  name: "Home",
  components: {
    DashboardAffiliate,
  },
  data() {
    return {
      //
    }
  },
  created(){
    //
  }
};
</script>
